import axios from 'axios';

const INITIAL_STATE = {
  isLoading: true,
  isLightMode: false,
  numberOfComponents: 0,
  event: {},
};

const state = () => INITIAL_STATE;

const mutations = {
  setLightMode(state, isLightMode) {
    state.isLightMode = isLightMode;
  },
  setEvent(state, event) {
    state.event = event;
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setNumberOfComponents(state, numberOfComponents) {
    state.numberOfComponents = numberOfComponents;
  },
};

const actions = {
  async getEvent({ commit, dispatch, rootState }, slug) {
    try {
      commit('setIsLoading', true);
      const accessToken = rootState.user.token;
      const headers = { Authorization: `Bearer ${accessToken}` };

      let event;

      // Try Strapi (v1) first
      try {
        const v1Response = await axios.get(process.env.VUE_APP_API_URL + '/eventpage/v1/' + slug, {
          headers,
        });
        event = v1Response.data[0];
      } catch (e) {
        // v1 failed, will try v2 below
      }

      // Fallback to Storyblok (v2) if Strapi returned nothing
      if (!event) {
        const v2Response = await axios.get(process.env.VUE_APP_API_URL + '/eventpage/v2/' + slug, {
          headers,
        });
        event = v2Response.data[0];
      }

      if (!event) {
        throw new Error('Event not found');
      }
      const numberOfComponents = event.thumbnail
        ? event.eventPageBlocks.length + 1
        : event.eventPageBlocks.length;

      commit('setEvent', event);
      commit('setLightMode', event.isLightMode);
      commit('setNumberOfComponents', numberOfComponents);
      commit('setIsLoading', false);
    } catch (e) {
      commit('setIsLoading', false);
      dispatch('toast/error', 'Failed to get event.', {
        root: true,
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
